/**
 * 서버가 준 다운로드 URL(S3 presigned)로 파일을 받는다.
 * 페이지를 떠나지 않게 임시 링크를 눌러 브라우저 다운로드로 넘긴다.
 */
export const downloadFromUrl = (url: string, fileName?: string) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  // 다른 출처(S3)라 이름은 서버 Content-Disposition 이 우선한다
  if (fileName) anchor.download = fileName;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
